import { render, staticRenderFns } from "./ImmutablePhraseCreatePopup.vue?vue&type=template&id=489f0d7a"
import script from "./ImmutablePhraseCreatePopup.vue?vue&type=script&lang=js"
export * from "./ImmutablePhraseCreatePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports